import styled from "styled-components";

export const Wrapper = styled.section``;

export const H5 = styled.p`
  text-align: center;
  font-size:12px;
`;

export const H4 = styled.h4`
  text-align: center;
`;
export const H3 = styled.h3`
  text-align: center;
`;